/**
 * @generated SignedSource<<96b634fc68eb432b6e099386ca51b6c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicWidgetsQuery$data = {
  readonly topic: {
    readonly " $fragmentSpreads": FragmentRefs<"hooksTopic" | "topicAdsTopic" | "topicDescriptionTopic">;
  };
  readonly " $fragmentType": "topicWidgetsQuery";
};
export type topicWidgetsQuery$key = {
  readonly " $data"?: topicWidgetsQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicWidgetsQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicWidgetsQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityId",
              "variableName": "entityId"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topic",
      "plural": false,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "hooksTopic",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "types",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Sponsor",
              "kind": "LinkedField",
              "name": "sponsor",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "topicAdsTopic"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "topicDescriptionTopic"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "18898b468f1506e50db785756a7926e6";

export default node;
